import * as React from 'react';

import { EAnswerType, EQuestionCode, EQuestionType } from '../../../types/form';
import { RawStringQuestionContainer } from '../../RawStringQuestionContainer';
import { CardsQuestionContainer } from '../../CardsQuestionContainer';
import { FioQuestionContainer } from '../../FIOQuestionContainer';
import { CardsChoseQuestionContainer } from '../../CardsChoseQuestionContainer';
import { PhoneVerificationContainer, PhoneValueContainer } from '../../PhoneVerificationContainer';
import { RangeQuestionContainer } from '../../RangeQuestionContainer';
import { EmailQuestionContainer } from '../../EmailQuestionContainer';
import { NumberQuestionContainer } from '../../NumberQuestionContainer';
import { PriceQuestionContainer, PriceRangeQuestionContainer } from '../../PriceQuestionContainer';
import { GeoContainer } from '../../GeoContainer';
import { AddressSuggestContainer } from '../../AddressSuggestContainer';
import { QuizCompletedContainer } from '../../QuizCompletedContainer';
import { QuizPersonalApplicationContainer } from '../../QuizPersonalApplicationContainer';
import { withFinalStep } from '../../withFinalStep';
import { TextareaCustomQuestionContainer } from '../../TextareaCustomQuestionContainer';
import { RealtorsListingContainer } from '../../RealtorsListingContainer';
import { HiddenSubmitterQuestion } from '../../HiddenSubmitterQuestionContainer';
import { TextareaQuestionContainer } from '../../TextareaQuestionContainer';
import { HiddenCalculationOfPeriodContainer } from '../../HiddenCalculationOfPeriodContainer/HiddenCalculationOfPeriodContainer';

interface IQuestionMapperParams {
  code: EQuestionCode;
  type: EQuestionType;
  answerType: EAnswerType;
  isLast?: boolean;
}

export const baseQuestionsMapper = ({ code, type, answerType }: IQuestionMapperParams) => {
  switch (code) {
    case EQuestionCode.Success:
      return QuizCompletedContainer;
    case EQuestionCode.FullName:
      return FioQuestionContainer;
    case EQuestionCode.PhoneValue:
      return PhoneValueContainer;
    case EQuestionCode.Phone:
    case EQuestionCode.PhoneVerify:
      return PhoneVerificationContainer;
    case EQuestionCode.Comment:
      return TextareaCustomQuestionContainer;
    case EQuestionCode.HiddenSubmitter:
      return HiddenSubmitterQuestion;
    case EQuestionCode.DealPeriodHidden:
      return HiddenCalculationOfPeriodContainer;
    case EQuestionCode.RealtorListing:
      return RealtorsListingContainer;
    case EQuestionCode.FormSentWithRealtors:
      return QuizPersonalApplicationContainer;
  }

  switch (type) {
    case EQuestionType.Input:
      return RawStringQuestionContainer;
    case EQuestionType.Textarea:
      return TextareaQuestionContainer;
    case EQuestionType.Address:
      return AddressSuggestContainer;
    case EQuestionType.GeoSuggest:
      return GeoContainer;
    case EQuestionType.Price:
      return answerType === EAnswerType.Range ? PriceRangeQuestionContainer : PriceQuestionContainer;
    case EQuestionType.Email:
      return EmailQuestionContainer;
    case EQuestionType.Number:
      return NumberQuestionContainer;
    case EQuestionType.OneChoice:
      return CardsQuestionContainer;
    case EQuestionType.MultiChoice:
      return CardsChoseQuestionContainer;
    case EQuestionType.Range:
      return RangeQuestionContainer;
    default:
      return RawStringQuestionContainer;
  }
};

export const useQuestionsMapper = (params: IQuestionMapperParams) => {
  const comp = baseQuestionsMapper(params);

  /** Мемо необходим, потому что HOC будет каждый раз возвращать разную обертку, даже когда comp не меняется! */
  return React.useMemo(() => {
    return params.isLast ? withFinalStep(comp) : comp;
  }, [comp, params.isLast]);
};
